import { Link } from 'react-router-dom';
import { GameLayout } from './GameLayout';

export function BunkerLanding() {
  return (
    <GameLayout>
      <BunkerLandingStyles />
      <span className="bk-land-label">/ Бункер · дискуссионная игра с автоматическим ведением</span>
      <h1 className="bk-land-title">Кого вы пустите<br />в <span>бункер</span>?</h1>
      <p className="bk-land-lede">Катастрофа уже случилась. Мест меньше, чем людей. Каждый получает закрытую карточку персонажа — профессию, здоровье, багаж, факты и слабости. Обсуждайте, раскрывайте характеристики и решайте, кто переживёт изоляцию.</p>
      <div className="bk-land-actions"><Link className="btn-primary lg" to="/play/bunker/create">Создать комнату →</Link><Link className="btn-ghost lg" to="/rooms">Войти по коду</Link></div>
      <div className="bk-land-grid">
        <Feature number="01" title="Автоматическое ведение" text="Система ведёт раунды, таймеры, голосование и переголосование. Отмеченный ведущий может поставить матч на паузу или переключить фазу." />
        <Feature number="02" title="Карточки в тайне" text="Закрытые характеристики передаются только владельцу сессии. Другие увидят лишь то, что игрок раскрыл в раунде." />
        <Feature number="03" title="Живые решения" text="Сценарий, бункер, персонажи и карты выбираются по seed. Игра воспроизводима, а карточки не делают одного игрока безусловным победителем." />
        <Feature number="04" title="Финальная история" text="Когда мест останется ровно столько, сколько нужно, система покажет состав и просимулирует шансы группы на выживание." />
      </div>
      <section className="bk-land-rules">
        <h2>Как проходит матч</h2>
        <ol>
          <li>Кто угодно создаёт комнату, отмечает ведущего и отправляет QR-код друзьям.</li>
          <li>Игроки входят без регистрации, выбирают имя, аватар и подтверждают готовность.</li>
          <li>Каждый получает закрытого персонажа и изучает его на своём телефоне.</li>
          <li>В каждом раунде игроки по очереди раскрывают характеристику, выступают и обсуждают кандидатов.</li>
          <li>Тайное голосование исключает одного игрока; ничья автоматически переходит в переголосование.</li>
          <li>Финальный состав попадает в бункер, а система рассказывает, что было дальше.</li>
        </ol>
      </section>
    </GameLayout>
  );
}

function Feature({ number, title, text }: { number: string; title: string; text: string }) {
  return <article className="bk-land-feature"><span>{number}</span><h3>{title}</h3><p>{text}</p></article>;
}

function BunkerLandingStyles() {
  return <style>{`
    .bk-land-label { font: 11px 'JetBrains Mono', monospace; color: var(--ink-faint); letter-spacing: .16em; text-transform: uppercase; }
    .bk-land-title { margin: 13px 0 0; font: 600 clamp(58px, 9vw, 112px)/.91 'Oswald', sans-serif; letter-spacing: -.04em; }
    .bk-land-title span { color: #d86f34; font-family: 'Playfair Display', serif; font-style: italic; letter-spacing: -.07em; }
    .bk-land-lede { max-width: 720px; margin: 26px 0 36px; color: var(--ink-dim); font-size: 18px; line-height: 1.55; }
    .bk-land-actions { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 62px; }
    .bk-land-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 13px; }
    .bk-land-feature { min-height: 230px; padding: 22px; background: var(--bg2); border: 1px solid var(--line); border-radius: 12px; }
    .bk-land-feature > span { color: #d86f34; font: 11px 'JetBrains Mono', monospace; letter-spacing: .15em; }
    .bk-land-feature h3 { margin: 15px 0 8px; font: 500 29px 'Oswald', sans-serif; }
    .bk-land-feature p { margin: 0; color: var(--ink-dim); font-size: 13px; line-height: 1.5; }
    .bk-land-rules { margin-top: 64px; max-width: 770px; }
    .bk-land-rules h2 { font: 600 44px 'Oswald', sans-serif; margin: 0 0 16px; }
    .bk-land-rules ol { color: var(--ink-dim); line-height: 1.65; padding-left: 22px; }
    .bk-land-rules li { padding-left: 4px; margin-bottom: 8px; }
    @media (max-width: 900px) { .bk-land-grid { grid-template-columns: 1fr 1fr; } }
    @media (max-width: 560px) { .bk-land-grid { grid-template-columns: 1fr; } .bk-land-lede { font-size: 16px; } }
  `}</style>;
}
